'use strict';

module.exports = require('./lib/ReactDOM');



//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-dom/index.js
// module id = 69
// module chunks = 4 5 6 7 8 9 10 11 12